import Marketplace from "@/views/console/Marketplace";
import C from "@/utils/constants";

export default [
  {
    path: "marketplace",
    component: Marketplace,
    meta: {
      roles: [C.ROLE.ADMIN, C.ROLE.AGENT_ENGAGEMENT, C.ROLE.BROKERAGE_ADMIN],
    },
    children: [
      {
        path: "",
        name: "marketplace",
        component: () =>
          import("@/components/console/marketplace/MarketplaceList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
          ],
          hotjar: true,
        },
      },
    ],
  },
];
